import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getData } from "../../../api/client";
import endpoints from "../../../api/endpoints";
import { blogImageSrc } from "../../../api/blogImage";

function BlogSection() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getData(endpoints.BLOGS)
      .then((data) => {
        setBlogs(data?.blogs?.slice(0, 3) || []);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  
  if (loading || !blogs.length) {
    return null;
  }

  return (
    <div className="blog-area py-100">
      <div className="container">
        <div className="site-title text-center mb-50">
          <h2>
            Latest <span className="text-gradient">News & Articles</span>
          </h2>
          <p>Stay updated with learning tips and industry insights.</p>
        </div>

        <div className="row g-4">
          {blogs.map((blog) => (
            <div className="col-md-6 col-lg-4" key={blog._id}>
              <div className="blog-item">
                <div className="blog-img">
                  <Link to={`/blog/${blog.slug}`}>
                    <img
                      src={blogImageSrc(blog.image)}
                      alt={blog.title}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = blogImageSrc();
                      }}
                    />
                  </Link>
                </div>

                <div className="blog-content">
                  <div className="blog-meta">
                    <span>{new Date(blog.createdAt).toLocaleDateString()}</span>
                    <span>Admin</span>
                  </div>

                  <h4 className="blog-title">
                    <Link to={`/blog/${blog.slug}`}>{blog.title}</Link>
                  </h4>

                  <Link to={`/blog/${blog.slug}`} className="blog-read">
                    Read More →
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BlogSection;
